import { NgModule } from '@angular/core';
import { IsContainedInControlValuePipe } from './is-contained-in-control-value-pipe.pipe';



@NgModule({
  declarations: [
    IsContainedInControlValuePipe,
  ],
  exports: [
    IsContainedInControlValuePipe,
  ]
})
export class IsContainedInControlValuePipeModule { }
